import React from 'react';
import { Layout } from '../components/layout/Layout';
import { LegalDocumentContent } from '../components/LegalDocumentContent';
import { useLegalDocument } from '../hooks/useLegalDocument';

export default function Terms() {
  const { document, loading } = useLegalDocument('terms');

  return (
    <Layout>
      <div className="section-padding">
        <div className="container-zinga">
          <h1 className="font-display text-3xl md:text-4xl font-bold mb-6">{document.title}</h1>
          {loading ? (
            <div className="card-zinga text-sm text-muted-foreground">Dokumentum betöltése…</div>
          ) : (
            <div className="card-zinga">
              <LegalDocumentContent content={document.content} />
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
